import { Typography } from "antd";
import { useAntTheme } from "hooks/useAntTheme/";
import { radius } from "@libertify/ui";

export const ConsentText = ({
  consentText,
  disabled = false,
}: {
  consentText: string;
  disabled?: boolean;
}) => {
  const { theme } = useAntTheme();
  return (
    <div
      style={{
        padding: "18px 10px",
        textAlign: "center",
        borderRadius: radius.box,
        border: `2px solid ${disabled ? theme.colorTextDisabled : theme.colorPrimary}`,
      }}
    >
      <Typography.Text
        style={{
          fontSize: 16,
          fontWeight: 500,
          color: disabled ? theme.colorTextDisabled : theme.colorTextBase,
        }}
      >
        {consentText}
      </Typography.Text>
    </div>
  );
};
